<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'Behind',
  data () {
    return {
      container: null,
      link: null,
      valvid: '',
      inter: '',
      page: 1,
      showMoreEnabled: true,
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  apollo: {
    page: {
      query: gql `query page($id: String!){
          page(id: $id){
            id page_containers{
              id container{titre id}
            }
          }
      }`,
      variables () {
        return {id: '0862c9f1-2919-4132-b05c-ed562d48bdc3'}
      },
      fetchPolicy: 'cache-first',
      update: data => data.page,
    },
  },
  components: {
    BaseLayout,
  },
  methods: {
  },
}
</script>
<template lang="pug">
base-layout
  div.backgroundtexture
  div.backgroundimg
  div.backgroundimgborder
  div.behind
    div.contentsection
      div.menucontent.fl.flex(v-for='p in page.page_containers')
        div.menustyle
          router-link(:to="{name: 'info-behind-show', params: {id: p.container.id} }") {{p.container.titre}}
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (min-width: 320px){
  .backgroundtexture{
  background-image: url("~@/assets/JWWC-SET-6_dark.jpg");
  background-size: cover;
  height: 100vh;
  width:100vw;
  z-index:-10;
  position:fixed;
  }
  .backgroundimg{
    background-image: url('~@/assets/textures/lightpaperfibers-light.jpg');
    width:calc(100vw - 40px);
    height: calc(100vh - 70px);
    position: absolute;
    z-index:-1;
    border-style: solid;
    margin: 50px 20px 20px 20px;
    border-color: #273342;
  }
  .backgroundimgborder{
    width:calc(100vw - 50px);
    height: calc(100vh - 85px);
    position: absolute;
    z-index:-1;
    border-style: double;
    border-width: 7px 7px 7px 7px;
    margin: 60px 25px 25px 25px;
    border-color: red;
  }
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    /*bottom: 5%;*/
    right: 10%;
    bottom:5%;
    color: white;
    background-color: red;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
    color: white;
    background-color: red;
  }
  .borderred{
    width:92vw;
    height: 91vh;
    position:absolute;
    border-style: solid;
    border-width: 3px 3px 3px 3px;
    border-color: red;
  }
  .film{
    & .titresection{
      font-family:Marketdeco;
      color: red;
      font-size: 20px;
      margin-bottom: 30px;
      & span{
        border-style: solid;
        border-width: 3px 0 3px 0;
        border-color: red;
        padding: 5px 10px 5px 10px;
      }
    }
    & .logosection{
      padding-top: 25%;
    }
    & .menucontent{
      width: 100%;
      & .menustyle{
        width: 280px;
        border-style: solid;
        border-width: 0 0 1px 0;
        text-align: left !important;
        border-color: red;
        padding:10px;
        /*font-family:Marketdeco;*/
        color: red;
        font-size: 18px;
        margin: 0 auto;
        margin-bottom: 20px;
      }
      & a{
        color:darkred;
      }
    }
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {
.boutonnext{
  font-family:BritannicBold;
  font-size: 20px;
  /*bottom: 5%;*/
  right: 55%;
  bottom:3%;
  color: white;
  background-color: red;
}
.boutonlast{
  font-family:BritannicBold;
  font-size: 20px;
  bottom: 3%;
  left: 8%;
  color: white;
  background-color: red;
}
.film{
  & .titrecontent{
    font-family:Marketdeco;
    color: red;
    font-size: 20px;
    margin-bottom: 30px;
    margin-top: 50px;
    & span{
      border-style: solid;
      border-width: 3px 0 3px 0;
      border-color: red;
      padding: 5px 10px 5px 10px;
    }
  }
  & .logosection{
    float:left;
    width: 45%;
    padding-top: 18%;
    padding-left:10%;
    /*height: 100vh;*/
  }
  & .contentsection{
    float:left;
    width: 50%;
    margin-top: 8%;
    margin-left:5%;
    & .menucontent{
      width: 90%;

      /*margin-top: 10%;*/
      & .menustyle{
        width: 280px;
        border-style: solid;
        border-width: 0 0 1px 0;
        text-align: left !important;
        border-color: red;
        padding:10px;
        /*font-family:Marketdeco;*/
        color: red;
        font-size: 18px;
        margin: 0 auto;
        /*margin-bottom: 20px;*/
      }
      & a{
        color:darkred;
      }
    }
  }
}
}
@media only screen and (min-width: 768px){
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
  }
  .film{
    & .logosection{
      padding-top: 18%;
    }
    & .contentsection{
      & .titresection{
        font-family:Marketdeco;
        color: red;
        font-size: 30px;
        margin-bottom: 50px;
        margin-top: 50px;
        & span{
          border-style: solid;
          border-width: 3px 0 3px 0;
          border-color: red;
          padding: 5px 10px 5px 10px;
        }
      }
      & .menucontent{
        width: 100%;
        & .menustyle{
          width: 500px;
          border-style: solid;
          border-width: 0 0 1px 0;
          text-align: left !important;
          border-color: red;
          padding:10px;
          /*font-family:Marketdeco;*/
          color: red;
          font-size: 26px;
          margin: 0 auto;
          margin-bottom: 20px;
        }
        & a{
          color:darkred;
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) and (orientation:landscape) {
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
  }
  .film{
    & .logosection{
      padding-top: 10%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Behind.vue?2bd1239e